<template>
    <div class="text-info text-size-5 text-center text-italic">
        <p v-for="achievement in achievements" class="my">{{ achievement }}</p>
    </div>
</template>

<script>
    export default {
        name: 'PartnersPageAchievements',
        props: ['achievements'],
    };
</script>
